/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CancellationDeclareRequestEndingChoiceEnum = {
    date: 'date',
    earliest: 'earliest'
};
/**
 * @export
 */
export const CancellationDeclareRequestTerminationTypeEnum = {
    extraordinary: 'extraordinary',
    ordinary: 'ordinary'
};
/**
 * Check if a given object implements the CancellationDeclareRequest interface.
 */
export function instanceOfCancellationDeclareRequest(value) {
    if (!('confirmationEmail' in value) || value['confirmationEmail'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('terminationType' in value) || value['terminationType'] === undefined)
        return false;
    return true;
}
export function CancellationDeclareRequestFromJSON(json) {
    return CancellationDeclareRequestFromJSONTyped(json, false);
}
export function CancellationDeclareRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brand': json['brand'] == null ? undefined : json['brand'],
        'confirmationEmail': json['confirmationEmail'],
        'contractRef': json['contractRef'] == null ? undefined : json['contractRef'],
        'email': json['email'],
        'endingChoice': json['endingChoice'] == null ? undefined : json['endingChoice'],
        'endingDate': json['endingDate'] == null ? undefined : (new Date(json['endingDate'])),
        'locale': json['locale'] == null ? undefined : json['locale'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'terminationType': json['terminationType'],
    };
}
export function CancellationDeclareRequestToJSON(json) {
    return CancellationDeclareRequestToJSONTyped(json, false);
}
export function CancellationDeclareRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brand': value['brand'],
        'confirmationEmail': value['confirmationEmail'],
        'contractRef': value['contractRef'],
        'email': value['email'],
        'endingChoice': value['endingChoice'],
        'endingDate': value['endingDate'] == null ? value['endingDate'] : value['endingDate'].toISOString().substring(0, 10),
        'locale': value['locale'],
        'reason': value['reason'],
        'terminationType': value['terminationType'],
    };
}
